import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M38.2 39.8H6.8c-.8 0-1.2-.9-.8-1.5l11.6-15.7h9.9L39 38.2a1 1 0 01-.8 1.6z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-white",
			cx: 20.5,
			cy: 28,
			r: 2.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-white",
			cx: 21.2,
			cy: 36.1,
			r: 1.3
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-white",
			cx: 27.5,
			cy: 32,
			r: 1.7
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M43.9 36L30.4 17.6V8.1h.5c2.2 0 4-1.8 4-4s-1.8-4-4-4H14.1c-2.2 0-4 1.8-4 4s1.8 4 4 4h.5v9.5L1.1 36c-1.3 1.7-1.5 4-.5 5.9 1 1.9 2.9 3.1 5 3.1h33.7c2.1 0 4.1-1.2 5.1-3.1 1-1.9.8-4.2-.5-5.9zm-1.7 4.8c-.5 1.1-1.6 1.7-2.8 1.7H5.7c-1.2 0-2.3-.6-2.8-1.7-.6-1.1-.4-2.3.3-3.3L17 18.7h3.6v-2.5h-3.4v-2.8h5.4v-2.5h-5.4V8.1h3.4V5.6h-6.3c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H31c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-3v12.9l14 19c.6.9.7 2.2.2 3.3z"
		})
	]
});
export default SvgIcon;
